import { withCompInfo } from '@wix/editor-elements-integrations'
import type { CollapsibleTextDefinition } from './CollapsibleText'

export const props = withCompInfo<any, CollapsibleTextDefinition>()(['compData'], ({ compData }) => {
	const { link = {} } = compData
	return { link }
})
